// Mobile drawer polish: animated accordion for top-level items and early image loading.
(() => {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	const OPEN_MS = 300;
	const CLOSE_MS = 220;
	const TOP_SUMMARY = '.menu-drawer__top-item > details > summary';

	function panelOf(details) {
		return details.querySelector(':scope > .menu-drawer__submenu');
	}

	// Closing a section above the one being opened pulls it upward, sometimes out of view
	function keepInView(summary) {
		const scroller = summary.closest('.menu-drawer__navigation-container');
		if (!scroller) return;
		const offset = summary.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
		if (offset < 0) {
			scroller.scrollBy({ top: offset - 8, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
		}
	}

	function setOpen(details, open) {
		const summary = details.querySelector(':scope > summary');
		const panel = panelOf(details);
		if (details._anim) {
			details._anim.cancel();
			details._anim = null;
		}
		summary.setAttribute('aria-expanded', String(open));

		if (open) {
			details.classList.remove('is-closing');
			details.setAttribute('open', '');
			if (reduceMotion.matches || !panel) {
				keepInView(summary);
				return;
			}
			const height = panel.scrollHeight;
			details._anim = panel.animate(
				[
					{ height: '0px', opacity: 0, transform: 'translateY(-4px)' },
					{ height: `${height}px`, opacity: 1, transform: 'translateY(0)' },
				],
				{ duration: OPEN_MS, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
			);
			details._anim.onfinish = () => {
				details._anim = null;
				keepInView(summary);
			};
			return;
		}

		if (reduceMotion.matches || !panel) {
			details.removeAttribute('open');
			return;
		}
		details.classList.add('is-closing');
		details._anim = panel.animate(
			[
				{ height: `${panel.offsetHeight}px`, opacity: 1 },
				{ height: '0px', opacity: 0 },
			],
			{ duration: CLOSE_MS, easing: 'cubic-bezier(0.4, 0, 1, 1)' }
		);
		details._anim.onfinish = () => {
			details.removeAttribute('open');
			details.classList.remove('is-closing');
			details._anim = null;
		};
	}

	document.addEventListener('click', (event) => {
		const summary = event.target.closest(TOP_SUMMARY);
		if (!summary) return;
		event.preventDefault();

		const details = summary.parentElement;
		const willOpen = !details.hasAttribute('open') || details.classList.contains('is-closing');

		// One section open at a time keeps the drawer short on small screens
		if (willOpen) {
			const list = details.closest('.menu-drawer__menu');
			list.querySelectorAll(':scope > .menu-drawer__top-item > details[open]').forEach((other) => {
				if (other !== details) setOpen(other, false);
			});
		}
		setOpen(details, willOpen);
	});

	// Images inside closed sections are lazy and only start loading when a section opens.
	// Start them as soon as the drawer is about to open so they are ready on first tap.
	let warmed = false;
	function warmDrawerImages() {
		if (warmed) return;
		warmed = true;
		document.querySelectorAll('.mega-drawer__img').forEach((img) => {
			img.loading = 'eager';
		});
	}

	function markLoaded(img) {
		img.classList.add('is-loaded');
	}

	document.addEventListener(
		'error',
		(event) => {
			if (event.target.classList && event.target.classList.contains('mega-drawer__img')) markLoaded(event.target);
		},
		true
	);

	function init() {
		document.querySelectorAll('.mega-drawer__img').forEach((img) => {
			if (img.complete && img.naturalWidth > 0) markLoaded(img);
		});
		const trigger = document.querySelector('header-drawer summary.header__icon--menu');
		if (!trigger) return;
		['pointerdown', 'touchstart', 'focus'].forEach((type) =>
			trigger.addEventListener(type, warmDrawerImages, { once: true, passive: true })
		);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
